var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 231,
    viewBox: "0 0 242 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.079 81.3417L161.563 70.8027L129.146 5.08395C128.261 3.28461 126.804 1.82801 125.005 0.942617C120.492 -1.28514 115.009 0.571325 112.752 5.08395L80.3358 70.8027L7.81954 81.3417C5.82028 81.6273 3.99237 82.5698 2.59289 83.9978C0.900986 85.7368 -0.0313287 88.0764 0.000803874 90.5024C0.0329365 92.9284 1.02689 95.2424 2.76425 96.936L55.2307 148.089L42.8353 220.319C42.5446 221.999 42.7305 223.728 43.372 225.307C44.0134 226.887 45.0848 228.256 46.4645 229.258C47.8442 230.26 49.477 230.856 51.1779 230.977C52.8788 231.098 54.5796 230.74 56.0875 229.944L120.949 195.842L185.811 229.944C187.582 230.887 189.639 231.201 191.609 230.858C196.579 230.001 199.92 225.289 199.064 220.319L186.668 148.089L239.135 96.936C240.563 95.5365 241.505 93.7086 241.791 91.7093C242.562 86.7111 239.078 82.0843 234.079 81.3417Z",
    fill: "#FF385C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d5e1ae1f36ff267057b96446a9e69309.svg";
export { ForwardRef as ReactComponent };